/**
 * Extension private mode: only these chains are exposed in the extension UI
 * (see useExtensionAwareNetworks).
 */
export const EXTENSION_PRIVATE_CHAIN_IDS: number[] = [
  1, // Ethereum
  42161, // Arbitrum
  // 137, // Polygon (not supported yet)
  56 // BNB Smart Chain
]

/**
 * Fallback private-mode chain when the dashboard filter is "All Networks" or an
 * unsupported chain. On mobile browsers we never scan all chains at once (memory),
 * so we clamp to this single chain. BNB Chain is the cheapest/lightest to scan.
 */
export const DEFAULT_MOBILE_PRIVATE_CHAIN_ID = 56 // BNB Smart Chain
